<template>
  <!-- A unit that isn't there has no tabs to offer; its page says so instead -->
  <SecondaryNavigation v-if="!propertyStore.isMissing(propertyId)" :links="navPanelLinks" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import { AppRouteNames } from '@tallo/investor/navigation';
import { usePropertyStore } from '@tallo/investor/property';

import { NavPanelLink } from '../root/nav-panel/nav-panel-link.interface';
import SecondaryNavigation from '../root/nav-panel/secondary-navigation.vue';

const route = useRoute();
const propertyStore = usePropertyStore();
// Read from the route every time: moving from one unit's page to another's keeps this component
const propertyId = computed(() => route.params.propertyId as string);

const navPanelLinks = computed<NavPanelLink[]>(() => {
  const params = { propertyId: propertyId.value };

  return [
    {
      id: 'prop-nav-dashboard',
      title: 'Dashboard',
      appRoute: AppRouteNames.INVESTOR_PROPERTY_DASHBOARD,
      params,
    },
    // A unit in a building shares the building's team, which is worked on the building's Team tab
    ...(propertyStore.property?.buildingId
      ? []
      : [{ id: 'prop-nav-team', title: 'Team', appRoute: AppRouteNames.INVESTOR_PROPERTY_TEAM, params }]),
    {
      id: 'prop-nav-details',
      title: 'Property Details',
      appRoute: AppRouteNames.INVESTOR_PROPERTY_DETAILS,
      params,
    },
    {
      id: 'prop-nav-availability',
      title: 'Availability',
      appRoute: AppRouteNames.INVESTOR_PROPERTY_AVAILABILITY,
      params,
    },
    {
      id: 'prop-nav-showings',
      title: 'Showings',
      appRoute: AppRouteNames.INVESTOR_PROPERTY_SHOWINGS,
      params,
    },
    {
      id: 'prop-nav-leads',
      title: 'Leads',
      appRoute: AppRouteNames.INVESTOR_PROPERTY_LEADS,
      params,
    },
    {
      id: 'prop-nav-applications',
      title: 'Applications',
      appRoute: AppRouteNames.INVESTOR_PROPERTY_APPLICATIONS,
      params,
    },
  ];
});
</script>
